import auth from '@udacity/ureact-hoth';

import { publicEnv } from '~/features/environment/public';
import { logger } from '~/features/logging/logger';
import { queryUdacityService } from '~/utils/query-udacity-service';

export async function postEnrollment(programKey: string, companyId?: string): Promise<void> {
  const jwt = auth.getJWT();
  const userId = auth.getCurrentUserId();

  if (!userId || !jwt) {
    logger.fatal('User is not authenticated', {
      file: 'src/features/program/controllers/post-enrollment.ts',
      function: 'postEnrollment',
      error: {
        jwt,
        userId,
      },
    });

    throw new Error('User is not authenticated');
  }

  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_ENROLLMENTS_URL}/v1/enrollments`,
    zodSchema: null,
    authorization: `Bearer ${jwt}`,
    body: JSON.stringify({
      node_key: programKey,
      state: 'ENROLLED',
      user_key: userId,
      company_id: companyId,
    }),
  });
}
